import { render, staticRenderFns } from "./SgmCertificateDetail.vue?vue&type=template&id=0b7645ca&scoped=true"
import script from "./SgmCertificateDetail.vue?vue&type=script&lang=js"
export * from "./SgmCertificateDetail.vue?vue&type=script&lang=js"
import style0 from "./SgmCertificateDetail.vue?vue&type=style&index=0&id=0b7645ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7645ca",
  null
  
)

export default component.exports